import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { database, auth }  from "../Components/FirebaseConfig";
import { ref, query, get, equalTo, on, onValue, orderByChild, limitToLast, onChildAdded } from "firebase/database";

import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PublicIcon from '@mui/icons-material/Public';

// import 'firebase/database';



import '../App.scss'
import logo from '../Assets/Images/profile.png'
import fire from '../Assets/Images/fire.svg'
import ambulance from '../Assets/Images/ambulance.svg'
import police from '../Assets/Images/police.svg'
import pin from '../Assets/Images/pin.svg'
import GoogleMapReact from 'google-map-react'
import { Place } from "@material-ui/icons";
import UserContext from '../store/UserContext';

const LocationPin = ({ text }) => (
	<div className="pin">
		{/* <div className="rectangle">
			<div className="location-icon"><img src={pin}/> Montclair</div>
			<p>{text}</p>
			<div className='triangle'></div>
		</div>		 */}
		{/* <div className="bigger-circle">
			<div className="smaller-circle">
				{''}
				<div className="circle">{''}</div>
			</div>
		</div>	 */}
    <div className="circle" style={{ animationDelay: "-3s" }}></div>
    <div className="circle" style={{ animationDelay: "-2s" }}></div>
    <div className="circle" style={{ animationDelay: "-1s" }}></div>
    <div className="circle" style={{ animationDelay: " 0s" }}></div>		
	</div>
)

const Location = () => {
	
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
  const { trackingId, lat, lng } = useParams();
  
	const [name, setName] = useState("");
	const [footerHeight, setFooterHeight] = useState(true);
	
	const [center, setCenter] = useState({
		lat:parseFloat(lat),
		lng: parseFloat(lng)
	});

	// Reset footer state when resizing to larger screen
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth > 800) {
				setFooterHeight(true);
			}
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	

	useEffect(() => {
		if (!trackingId) return;
		const dbRef = ref(database, '/tracking/' + trackingId);
		const unsubscribe = onChildAdded(dbRef, (snapshot) => {
			const newItem = snapshot.val();
			console.log("Latest ",newItem.lat, newItem.lng);

			if(newItem.lat){
				setCenter({
					lat: newItem.lat, 
					lng: newItem.lng 
				});
			}
		});
	
		return () => {
		  unsubscribe();
		};
	}, [trackingId]);

	useEffect(() => {
		if (!trackingId) return;
		get(query(ref(database, '/tracking/' + trackingId), limitToLast(1)))
		.then((snapshot) => {
			if (snapshot.exists()) {
				snapshot.forEach((item) => {
					console.log(item.val().name);
					userCtx.setName(item.val().name);
					userCtx.setPhone(item.val().phone);
				});
			}
		});
		// var userQuery = trackingRef.orderByChild('trackingId').equalTo(trackingId);
		// userQuery.once("value", function(snapshot) {
		// 	snapshot.forEach(function(child) {
		// 		console.log(child.key, child.val());
		// 	});
		// });

	}, [trackingId, userCtx]);

	const footerHandler = (e) => {
		e.preventDefault();
		setFooterHeight(!footerHeight);
	}

	return (
		<>
			<div className="location page-simulate">
				<div className="map">
					{console.log("this is value", center)}
					{center.lat ? <Map center={center} zoom={17} /> : <div>Loading</div>}
					
				</div>

				<div className="footer-container" style={footerHeight ? { height: "52px" } :  { height: "250px" }} >
          <div className="location-footer">
            <button className="show-footer" onClick={footerHandler}>{!footerHeight ? <ExpandMoreRoundedIcon /> : <ExpandLessRoundedIcon />}</button>
            <div className="details-row">
              <div className="single-detail panic-name">
                <div className="detail-title-row">
                  <span className="title">{userCtx.name}</span>
                </div>
                <span className="phone-number">
                  <a href={`tel:${userCtx.phone}`}>{userCtx.phone}</a>
                </span>
              </div>

              <div className="single-detail">
                <div className="detail-title-row">
                  <img src={police} alt="test" /><span className="service-title">Police</span>
                </div>
                <span className="phone-number">
                  <a href="tel:9623432186">9623432186</a>
                </span>
              </div>

              <div className="single-detail">
                <div className="detail-title-row">
                  <img src={ambulance} alt="test" /><span className="service-title">Ambulance</span>
                </div>
                <span className="phone-number">
                  <a href="tel:110177">110177</a>
                </span>
              </div>

              <div className="single-detail">
                <div className="detail-title-row">
                  <img src={fire} alt="test" /><span className="service-title">Fire Department</span>
                </div>
                <span className="phone-number">
                  <a href="tel:11022">11022</a>
                </span>
              </div>

              <div className="single-detail">
                <div className="detail-title-row">
                  <PublicIcon className="detail-icon" /><span className="service-title">International Emergency</span>
                </div>
                <span className="phone-number">
                  <a href="tel:112">112</a>
                </span>
              </div>

            </div>
          </div>
        </div>
			</div>
		</>
	)
}

export default Location;


const MAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const MapLoadError = () => (
	<div className="map-load-error" style={{
		position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
		background: '#f5f5dc', padding: 24, textAlign: 'center', flexDirection: 'column', gap: 12, boxSizing: 'border-box'
	}}>
		<strong>Map could not load</strong>
		<p style={{ margin: 0, fontSize: 14, maxWidth: 420 }}>
			Open DevTools → <strong>Network</strong> tab and find the request to <code>maps.googleapis.com/maps/api/js</code>.
		</p>
		<ul style={{ margin: '8px 0 0', paddingLeft: 20, fontSize: 13, textAlign: 'left' }}>
			<li>If status is <strong>403</strong>: enable &quot;Maps JavaScript API&quot;, enable billing, and add <code>http://localhost:3000/*</code> to your API key&apos;s HTTP referrer restrictions.</li>
			<li>If status is <strong>200</strong> but tiles are gray: check the response body for error messages (e.g. RefererNotAllowedMapError).</li>
		</ul>
	</div>
);

const Map = ({ center, zoom }) => {
	const [mapLoadError, setMapLoadError] = useState(false);
	const [mapInstance, setMapInstance] = useState(null);
	const [mapsApi, setMapsApi] = useState(null);
	const [mapType, setMapType] = useState('roadmap');
	const [isFullscreen, setIsFullscreen] = useState(false);
	const mapContainerRef = useRef(null);

	const handleApiLoaded = ({ map, maps }) => {
		if (!map || !maps) {
			setMapLoadError(true);
			return;
		}
		setMapInstance(map);
		setMapsApi(maps);
	};

	const setMapTypeId = (type) => {
		if (!mapInstance || !mapsApi) return;
		const id = type === 'satellite' ? mapsApi.MapTypeId.SATELLITE : mapsApi.MapTypeId.ROADMAP;
		mapInstance.setMapTypeId(id);
		setMapType(type);
	};

	const toggleFullscreen = () => {
		if (!mapContainerRef.current) return;
		if (!document.fullscreenElement) {
			mapContainerRef.current.requestFullscreen?.().then(() => setIsFullscreen(true)).catch(() => {});
		} else {
			document.exitFullscreen?.().then(() => setIsFullscreen(false)).catch(() => {});
		}
	};

	useEffect(() => {
		const onFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
		document.addEventListener('fullscreenchange', onFullscreenChange);
		return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
	}, []);

	const getMapOptions = (maps) => ({
		mapTypeControl: false,
		mapTypeId: mapType === 'satellite' ? maps.MapTypeId.SATELLITE : maps.MapTypeId.ROADMAP,
	});

	return (
		<div ref={mapContainerRef} className="map-item map-toolbar-container" style={{ position: 'relative' }}>
			{mapLoadError && <MapLoadError />}
			<div className="map-toolbar">
				<div className="map-toolbar-group">
					<button
						type="button"
						className={`map-toolbar-btn ${mapType === 'roadmap' ? 'active' : ''}`}
						onClick={() => setMapTypeId('roadmap')}
						aria-label="Street view"
					>
						Street
					</button>
					<button
						type="button"
						className={`map-toolbar-btn ${mapType === 'satellite' ? 'active' : ''}`}
						onClick={() => setMapTypeId('satellite')}
						aria-label="Satellite view"
					>
						Satellite
					</button>
				</div>
				<button
					type="button"
					className="map-toolbar-btn map-toolbar-maximize"
					onClick={toggleFullscreen}
					aria-label={isFullscreen ? 'Exit fullscreen' : 'Maximize'}
				>
					{isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
				</button>
			</div>
			<GoogleMapReact
				options={getMapOptions}
				bootstrapURLKeys={{ key: MAP_KEY, authReferrerPolicy: 'origin' }}
				center={center}
				defaultZoom={zoom}
				gestureHandling="none"
				yesIWantToUseGoogleMapApiInternals
				onGoogleApiLoaded={handleApiLoaded}
			>
				<LocationPin
					lat={center.lat}
					lng={center.lng}
					text="1600 Amphitheatre Parkway, Mountain View, california."
				/>
			</GoogleMapReact>
		</div>
	);
};
